<template>
  <div>
    <div class="columns">
      <div class="column">
        <b-field
          id="title"
          :label="$t('kyc.name_title')"
        >
          <div data-test="kyc-information--title-radio">
            <b-radio
              v-validate="'required'"
              v-model="form.nameTitle"
              native-value="Mr."
              name="title"
              @click.native="$emit('trackInputForm', { key: 'nameTitle', name: 'title', page: 'Information' })"
            >
              {{ $t('kyc.mr') }}
            </b-radio>
            <b-radio
              v-validate="'required'"
              v-model="form.nameTitle"
              native-value="Miss."
              name="title"
              @click.native="$emit('trackInputForm', { key: 'nameTitle', name: 'title', page: 'Information' })"
            >
              {{ $t('kyc.miss') }}
            </b-radio>
            <b-radio
              v-validate="'required'"
              v-model="form.nameTitle"
              native-value="Mrs."
              name="title"
              @click.native="$emit('trackInputForm', { key: 'nameTitle', name: 'title', page: 'Information' })"
            >
              {{ $t('kyc.mrs') }}
            </b-radio>
          </div>
        </b-field>
        <span class="is-invalid">{{ errors.first('title') }}</span>
      </div>
    </div>
    <div
      v-if="form.nationality === 'Thai'"
      class="columns"
    >
      <div class="column">
        <b-field
          id="first-name-thai"
          :label="$t('kyc.first_name_th')"
        >
          <b-input
            v-validate="'required'"
            v-model="form.firstNameInThai"
            :placeholder="$t('kyc.first_name_th')"
            name="first name (Thai)"
            autocomplete="disabled"
            data-test="kyc-information--first-name-thai-field"
            @blur="$emit('trackInputForm', { key: 'firstNameInThai', name: 'first name (Thai)', page: 'Information' })"
          />
        </b-field>
        <span class="is-invalid">{{ errors.first('first name (Thai)') }}</span>
      </div>
      <div class="column">
        <b-field
          id="last-name-thai"
          :label="$t('kyc.last_name_th')"
        >
          <b-input
            v-validate="'required'"
            v-model="form.lastNameInThai"
            :placeholder="$t('kyc.last_name_th')"
            name="last name (Thai)"
            autocomplete="disabled"
            data-test="kyc-information--last-name-thai-field"
            @blur="$emit('trackInputForm', { key: 'lastNameInThai', name: 'last name (Thai)', page: 'Information' })"
          />
        </b-field>
        <span class="is-invalid">{{ errors.first('last name (Thai)') }}</span>
      </div>
    </div>
    <div class="columns">
      <div class="column">
        <b-field
          id="first-name"
          :label="$t('kyc.first_name')"
        >
          <b-input
            v-validate="'required'"
            v-model="form.firstName"
            :placeholder="$t('kyc.first_name')"
            name="first name"
            autocomplete="disabled"
            data-test="kyc-information--first-name-field"
            @blur="$emit('trackInputForm', { key: 'firstName', name: 'first name', page: 'Information' })"
          />
        </b-field>
        <span class="is-invalid">{{ errors.first('first name') }}</span>
      </div>
      <div
        v-if="form.nationality !== 'Thai'"
        class="column"
      >
        <b-field
          id="middle-name"
          :label="$t('kyc.middle_name')"
        >
          <b-input
            v-model="form.middleName"
            :placeholder="$t('kyc.middle_name')"
            name="middle name"
            autocomplete="disabled"
            data-test="kyc-information--middle-name-field"
            @blur="$emit('trackInputForm', { key: 'middleName', name: 'middle name', page: 'Information' })"
          />
        </b-field>
        <span class="is-invalid">{{ errors.first('middle name') }}</span>
      </div>
      <div class="column">
        <b-field
          id="last-name"
          :label="$t('kyc.last_name')"
        >
          <b-input
            v-validate="'required'"
            v-model="form.lastName"
            :placeholder="$t('kyc.last_name')"
            name="last name"
            autocomplete="disabled"
            data-test="kyc-information--last-name-field"
            @blur="$emit('trackInputForm', { key: 'lastName', name: 'last name', page: 'Information' })"
          />
        </b-field>
        <span class="is-invalid">{{ errors.first('last name') }}</span>
      </div>
    </div>
    <div class="columns">
      <div class="column">
        <b-field
          id="gender"
          :label="$t('kyc.gender')"
        >
          <div data-test="kyc-information--gender-radio">
            <b-radio
              v-validate="'required'"
              v-model="form.gender"
              native-value="Male"
              name="gender"
              @click.native="$emit('trackInputForm', { key: 'gender', name: 'gender', page: 'Information' })"
            >
              {{ $t('kyc.male') }}
            </b-radio>
            <b-radio
              v-validate="'required'"
              v-model="form.gender"
              native-value="Female"
              name="gender"
              @click.native="$emit('trackInputForm', { key: 'gender', name: 'gender', page: 'Information' })"
            >
              {{ $t('kyc.female') }}
            </b-radio>
          </div>
        </b-field>
        <span class="is-invalid">{{ errors.first('gender') }}</span>
      </div>
      <div class="column">
        <b-field
          id="marital-status"
          :label="$t('kyc.marital_status')"
        >
          <div data-test="kyc-information--marital-status-radio">
            <b-radio
              v-validate="'required'"
              v-model="form.maritalStatus"
              native-value="Single"
              name="marital status"
              @click.native="$emit('trackInputForm', { key: 'maritalStatus', name: 'marital status', page: 'Information' })"
            >
              {{ $t('kyc.single') }}
            </b-radio>
            <b-radio
              v-validate="'required'"
              v-model="form.maritalStatus"
              native-value="Married"
              name="marital status"
              @click.native="$emit('trackInputForm', { key: 'maritalStatus', name: 'marital status', page: 'Information' })"
            >
              {{ $t('kyc.married') }}
            </b-radio>
          </div>
        </b-field>
        <span class="is-invalid">{{ errors.first('marital status') }}</span>
      </div>
    </div>
    <div class="columns">
      <div class="column">
        <b-field
          id="date-of-birth"
          :label="$t('kyc.date_of_birth')"
          data-test="kyc-information--birthdate"
        >
          <b-datepicker
            v-validate="'required|ageMoreThanTwenty'"
            v-model="form.birthdate"
            :mobile-native="false"
            :years-range="[-200, 200]"
            :placeholder="$t('kyc.click_to_select')"
            icon="calendar-today"
            name="date of birth"
            @input="$emit('trackInputForm', { key: 'birthdate', name: 'date of birth', page: 'Information' })"
          />
        </b-field>
        <span class="is-invalid">{{ errors.first('date of birth') }}</span>
      </div>
      <div class="column">
        <b-field
          id="phone-number"
          :label="$t('kyc.tel_number')"
        >
          <b-input
            v-validate="'required'"
            v-model="form.tel"
            :placeholder="$t('kyc.tel_placeholder')"
            name="phone number"
            autocomplete="disabled"
            data-test="kyc-information--phone-number-field"
            @blur="$emit('trackInputForm', { key: 'tel', name: 'phone number', page: 'Information' })"
          />
        </b-field>
        <span class="is-invalid">{{ errors.first('phone number') }}</span>
      </div>
    </div>
    <div class="columns">
      <div
        v-if="!occupationUnspecifiedCompany.includes(form.career)"
        class="column">
        <b-field
          id="working-at-company"
          :label="$t('kyc.your_company')"
          class="kyc-information-is-expanded"
        >
          <b-input
            v-validate="'required'"
            v-model="form.workingAtCompanyName"
            :placeholder="$t('kyc.company_placholder')"
            name="working at company"
            autocomplete="disabled"
            data-test="kyc-information--working-at-company-field"
            @blur="$emit('trackInputForm', { key: 'workingAtCompanyName', name: 'working at company', page: 'Information' })"
          />
        </b-field>
        <span class="is-invalid">{{ errors.first('working at company') }}</span>
      </div>
      <div class="column">
        <b-field
          id="occupation"
          :label="$t('kyc.occupation')"
          class="kyc-information-is-expanded"
        >
          <b-select
            v-validate="'required'"
            v-model="form.career"
            :placeholder="$t('kyc.occupation')"
            name="occupation"
            data-test="kyc-information--occupation-field"
            @blur="$emit('trackInputForm', { key: 'career', name: 'occupation', page: 'Information' })"
          >
            <option
              v-for="occupation in sortOccupationList"
              :value="occupation.key"
              :key="occupation.key"
              name="occupation"
            >
              {{ occupation[$i18n.locale] }}
            </option>
          </b-select>
        </b-field>
        <span class="is-invalid">{{ errors.first('occupation') }}</span>
      </div>
    </div>
    <!-- Career 'Other' or 'Freelance' should specify detail -->
    <div
      v-if="['OC54', 'OC47'].includes(form.career)"
      class="columns"
    >
      <div class="column">
        <b-field
          id="occupation-specify-detail"
          :label="$t('kyc.occupation_specify_detail')"
        >
          <b-input
            v-validate="'required'"
            v-model="form.careerOther"
            :placeholder="$t('kyc.occupation_specify_detail_placeholder')"
            name="occupation specify detail"
            data-test="kyc-information--occupation-specify-detail"
            @blur="$emit('trackInputForm', { key: 'careerOther', name: 'occupation specify detail', page: 'Information' })"
          />
        </b-field>
        <span class="is-invalid">{{ errors.first('occupation specify detail') }}</span>
      </div>
    </div>
    <div class="columns">
      <div class="column">
        <b-field
          id="average-income"
          :label="$t('kyc.avg_income')"
          class="kyc-information-is-expanded"
        >
          <b-select
            v-validate="'required'"
            v-model="form.averageIncome"
            :placeholder="$t('kyc.avg_income')"
            name="average income"
            data-test="kyc-upload-doc-hight-risk--average-income-field"
          >
            <option
              v-for="income in averageIncomeList"
              :value="income.key"
              :key="income.key"
              name="income"
            >
              {{ income[$i18n.locale] }}
            </option>
          </b-select>
        </b-field>
        <span class="is-invalid">{{ errors.first('average income') }}</span>
      </div>
    </div>
    <UploadDocumentHightRisk
      v-if="occupationLevel === 10"
      :form="form"
    />
    <!-- Working company address -->
    <div
      v-if="!occupationUnspecifiedCompany.includes(form.career)"
      class="columns dp-flex"
    >
      <div class="column">
        <b-field
          id="working-at-company-address"
          :label="$t('kyc.your_company_address')"
        >
          <b-input
            v-validate="'required'"
            v-model="form.workingAtCompanyAddressLineOne"
            :placeholder="$t('kyc.address_placeholder')"
            name="working at company address"
            autocomplete="disabled"
            expanded
            data-test="kyc-information--working-at-company-address-field"
            @blur="$emit('trackInputForm', { key: 'workingAtCompanyAddressLineOne', name: 'working at company address', page: 'Information' })"
          />
        </b-field>
        <span class="is-invalid">{{ errors.first('working at company address') }}</span>
      </div>
    </div>
    <div
      v-if="!occupationUnspecifiedCompany.includes(form.career)"
      class="columns dp-flex"
    >
      <div class="column">
        <b-field :label="$t('kyc.your_company_address_line_2')">
          <b-input
            v-model="form.workingAtCompanyAddressLineTwo"
            :placeholder="$t('kyc.address_placeholder')"
            name="working at company address line two"
            autocomplete="disabled"
            expanded
            data-test="kyc-information--working-at-company-address-line-2-field"
            @blur="$emit('trackInputForm', { key: 'workingAtCompanyAddressLineTwo', name: 'working at company address line two', page: 'Information' })"
          />
        </b-field>
      </div>
    </div>
    <div
      v-if="!occupationUnspecifiedCompany.includes(form.career)"
      class="columns dp-flex"
    >
      <div class="column">
        <b-field
          id="working-at-company-country"
          :label="$t('kyc.your_company_country')"
          class="kyc-country-is-expanded"
        >
          <b-select
            v-validate="'required'"
            v-model="form.workingAtCompanyCountry"
            :placeholder="$t('kyc.country')"
            name="working at company country"
            data-test="kyc-information--working-at-company-country-field"
            @blur="$emit('trackInputForm', { key: 'workingAtCompanyCountry', name: 'working at company country', page: 'Information' })"
            @input="() => {
              form.workingAtCompanyProvince = ''
              $forceUpdate()
            }"
          >
            <option
              v-for="(country, index) in countries"
              :value="country.en_short_name"
              :key="index"
              :disabled="country.disabled"
            >
              {{ country.en_short_name }}
            </option>
          </b-select>
        </b-field>
        <span class="is-invalid">{{ errors.first('working at company country') }}</span>
      </div>
      <div class="column">
        <b-field
          id="working-at-company-postcode"
          :label="$t('kyc.your_company_zipcode')"
        >
          <ThailandAutoComplete
            v-validate="form.workingAtCompanyCountry === 'Thailand' ? 'required|numeric|length:5': 'required'"
            v-if="form.workingAtCompanyCountry === 'Thailand'"
            id="kyc-information--working-at-company-postcode-field"
            v-model="form.workingAtCompanyPostcode"
            :placeholder="$t('kyc.zipcode')"
            color="#337ab7"
            name="working at company postcode"
            type="zipcode"
            autocomplete="disabled"
            expanded
            @select="(address) => selectThailandAddrAutoComplete(address)"
            @blur="$emit('trackInputForm', { key: 'workingAtCompanyPostcode', name: 'working at company postcode', page: 'Information' })"
          />
          <b-input
            v-validate="form.workingAtCompanyCountry === 'Thailand' ? 'required|numeric|length:5': 'required'"
            v-else
            v-model="form.workingAtCompanyPostcode"
            :placeholder="$t('kyc.zipcode')"
            name="working at company postcode"
            autocomplete="disabled"
            expanded
            data-test="kyc-information--working-at-company-postcode-field"
            @blur="$emit('trackInputForm', { key: 'workingAtCompanyPostcode', name: 'working at company postcode', page: 'Information' })"
          />
        </b-field>
        <span class="is-invalid">{{ errors.first('working at company postcode') }}</span>
      </div>
    </div>
    <div
      v-if="!occupationUnspecifiedCompany.includes(form.career)"
      class="columns dp-flex"
    >
      <div class="column">
        <b-field
          id="working-at-company-city"
          :label="$t('kyc.your_company_city')"
        >
          <ThailandAutoComplete
            v-validate="'required'"
            v-if="form.workingAtCompanyCountry === 'Thailand'"
            v-model="form.workingAtCompanyCity"
            :placeholder="$t('kyc.city_placeholder')"
            color="#337ab7"
            name="working at company city"
            type="amphoe"
            data-test="kyc-information--working-at-company-city-field"
            expanded
            @select="(address) => selectThailandAddrAutoComplete(address)"
            @blur="$emit('trackInputForm', { key: 'workingAtCompanyCity', name: 'working at company city', page: 'Information' })"
          />
          <b-input
            v-validate="'required'"
            v-else
            v-model="form.workingAtCompanyCity"
            :placeholder="$t('kyc.city_placeholder')"
            name="working at company city"
            autocomplete="disabled"
            expanded
            data-test="kyc-information--working-at-company-city-field"
            @blur="$emit('trackInputForm', { key: 'workingAtCompanyCity', name: 'working at company city', page: 'Information' })"
          />
        </b-field>
        <span class="is-invalid">{{ errors.first('working at company city') }}</span>
      </div>
      <div class="column">
        <b-field
          id="working-at-company-province"
          :label="$t('kyc.your_company_province')"
        >
          <b-select
            v-validate="'required'"
            v-if="form.workingAtCompanyCountry === 'Thailand'"
            v-model="form.workingAtCompanyProvince"
            :placeholder="$t('kyc.province_placeholder')"
            name="working at company province"
            expanded
            data-test="kyc-information--working-at-company-province-field"
            @blur="$emit('trackInputForm', { key: 'workingAtCompanyProvince', name: 'working at company province', page: 'Information' })"
            @input="clearAutoCompleteAddress()"
          >
            <option
              v-for="province in provincesInThailand"
              :value="province.key"
              :key="province.key"
            >
              {{ province.th }}
            </option>
          </b-select>
          <b-input
            v-validate="'required'"
            v-else
            v-model="form.workingAtCompanyProvince"
            :placeholder="$t('kyc.province_placeholder')"
            name="working at company province"
            autocomplete="disabled"
            expanded
            data-test="kyc-information--working-at-company-province-field"
            @blur="$emit('trackInputForm', { key: 'workingAtCompanyProvince', name: 'working at company province', page: 'Information' })"
          />
        </b-field>
        <span class="is-invalid">{{ errors.first('working at company province') }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import UploadDocumentHightRisk from '../UploadDocumentHightRisk'
import ThailandAutoComplete from 'vue-thailand-address-autocomplete'
import { sortDataByLanguage } from '@/utils/helper'

export default {
  name: 'Information',
  inject: ['$validator'],
  components: {
    UploadDocumentHightRisk,
    ThailandAutoComplete
  },
  props: {
    form: {
      type: Object,
      default: () => {}
    },
    countries: {
      type: Array,
      default: () => []
    },
    occupationList: {
      type: Array,
      default: () => []
    },
    averageIncomeList: {
      type: Array,
      default: () => []
    },
    provincesInThailand: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      occupationUnspecifiedCompany: ['OC42', 'OC43', 'OC47', 'OC53'] // Student, Unemployed, Freelance, Retired
    }
  },
  computed: {
    occupationLevel () {
      const result = this.occupationList.find(val => val.key === this.form.career)
      return result && result.riskLevel
    },
    sortOccupationList () {
      return sortDataByLanguage(this.occupationList, this.$i18n.locale)
    },
    computedForm: function () {
      return Object.assign({}, this.form)
    }
  },
  watch: {
    computedForm: {
      handler: function (newVal, oldVal) {
        if (oldVal.career !== newVal.career && this.occupationUnspecifiedCompany.includes(newVal.career)) {
          this.$nextTick(() => {
            this.form.workingAtCompanyName = ''
            this.form.workingAtCompanyAddressLineOne = ''
            this.form.workingAtCompanyAddressLineTwo = ''
            this.form.workingAtCompanyCountry = ''
            this.form.workingAtCompanyPostcode = ''
            this.form.workingAtCompanyCity = ''
            this.form.workingAtCompanyProvince = ''
          })
        }
        if (oldVal.career !== newVal.career) {
          this.$nextTick(() => {
            delete this.form.careerOther
          })
        }
      },
      deep: true
    }
  },
  beforeDestroy () {
    this.$validator.pause()
  },
  methods: {
    selectThailandAddrAutoComplete (address) {
      this.form.workingAtCompanyPostcode = address.zipcode
      this.form.workingAtCompanyCity = address.amphoe
      this.form.workingAtCompanyProvince = this.provincesInThailand.find(p => p.th === address.province).key
      this.$forceUpdate()
    },
    clearAutoCompleteAddress () {
      this.form.workingAtCompanyPostcode = ''
      this.form.workingAtCompanyCity = ''
      this.$forceUpdate()
    }
  }
}
</script>

<style lang="scss">
.kyc-information-is-expanded {
  .control {
    .select {
      width: 100%;
      select {
        width: 100%;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/KYC/components/Personal/Information.vue